import BaseModel from '../../base';
import IssuanceTag from '../issuance-tag/index';

import { localeFormatDefault, serverDateDefault } from '@/plugins/date-print';

export default class TaskSettings extends BaseModel {
  constructor(settings = {}, url) {
    super(settings, url);

    this.is_moderated = settings.is_moderated || false;
    this.is_online = settings.is_online || false;
    this.is_appeal = settings.is_appeal || false;
    this.passing_score = settings.passing_score || false;
    this.minutes_to_solve = settings.minutes_to_solve || 0;
    this.issuance_tags = (settings.issuance_tags || []).map((tag) => new IssuanceTag(tag, 'issuance_tag'));
    this.show_all_questions = !this.issuance_tags.length;
    this.attempts = settings.attempts || 1;
    this.available_start_at = settings.available_start_at || null;
    this.available_end_at = settings.available_end_at || null;
    this.expertise_start_at = settings.expertise_start_at || null;
    this.expertise_end_at = settings.expertise_end_at || null;
    this.max_estimate = settings.max_estimate || 1;
    this.recalculate_100 = settings.recalculate_100 || false;
    this.can_add_attempts = settings.can_add_attempts || false;
    this.anonymous = settings.anonymous ?? true;
  }

  get availableDates() {
    const { available_start_at, available_end_at } = this;
    return [localeFormatDefault(available_start_at), localeFormatDefault(available_end_at)];
  }

  set availableDates([start, end]) {
    this.available_start_at = start ? serverDateDefault(start) : null;
    this.available_end_at = end ? serverDateDefault(end) : null;
  }

  get expertiseDates() {
    const { expertise_start_at, expertise_end_at } = this;
    return [localeFormatDefault(expertise_start_at), localeFormatDefault(expertise_end_at)];
  }

  set expertiseDates([start, end]) {
    this.expertise_start_at = start ? serverDateDefault(start) : null;
    this.expertise_end_at = end ? serverDateDefault(end) : null;
  }
}
